import { IBidResponse } from '../../../typings/IPrebid'

export function isNativeVideo(bid: IBidResponse): boolean {
  return (
    !!bid.native &&
    !!bid.native.video &&
    !!(bid.native.video.vastUrl || bid.native.video.vastXml)
  )
}
